import { render, staticRenderFns } from "./InactiveEventPage.vue?vue&type=template&id=2e2cf51a&scoped=true&"
import script from "./InactiveEventPage.vue?vue&type=script&lang=js&"
export * from "./InactiveEventPage.vue?vue&type=script&lang=js&"
import style0 from "./InactiveEventPage.vue?vue&type=style&index=0&id=2e2cf51a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2cf51a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VFadeTransition,VIcon})
